<template>
	<div class="login rel" ref="caogaoxiang">
		<el-image fit="contain" class="mt-33 ml-63 abs" :src="require('@/assets/logo2x.png')" alt=""
			style="height: .42rem;" />

		<div class="bj-0 br-11 juzhong abs flex a-center column">
			<div class="w78 for_nr h100">
				<el-tabs v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="Email" name="Email">
						<div class="f-18 mt-10 mb-25" style="color: #666666;">Please switch to "SEMS" and login if you
							have a SEMS account.</div>
						<div class="pt-30 pb-30 flex a-center anniu anniu1 bj-f2 br-8  mb-12" round type="primary"> <i
								class="el-icon-s-custom mr-20 ml-30 f-16 line-21" /> <el-input v-model="shu.account"
								placeholder="User name" /></div>
						<div class="pt-30 pb-30 flex a-center anniu anniu2 bj-f2 br-8" round type="primary"> <i class="el-icon-lock
		mr-20 ml-30 f-16 line-21" /> <el-input v-model="shu.password" type="password" placeholder="Password" /></div>
						<div class="flex j-between mt-26 mb-40">
							<div class="cur_pointer" style="color: #666666;">Sign up now</div>
							<div class="cur_pointer" style="color: #E72333;" @click="dialog = true">Forgot your
								Password？</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="Sems" name="Sems">
						<div class="f-18 mt-10 mb-25" style="color: #666666;opacity: 0;"> 1 </div>
						<div class="pt-30 pb-30 flex a-center anniu anniu1 bj-f2 br-8  mb-12" round type="primary"> <i
								class="el-icon-s-custom mr-20 ml-30 f-16 line-21" /> <el-input v-model="shu.account"
								placeholder="SEMS ID" /></div>
						<div class="pt-30 pb-30 flex a-center anniu anniu2 bj-f2 br-8" round type="primary"> <i class="el-icon-lock
		mr-20 ml-30 f-16 line-21" /> <el-input v-model="shu.password" type="password" placeholder="Password" /></div>
						<div class="flex j-between mt-26 mb-40">
							<div class="cur_pointer" style="color: #666666;">Sign up now</div>
							<div class="cur_pointer" style="color: #E72333;" @click="dialog = true">Forgot your
								Password？</div>
						</div>
					</el-tab-pane>
				</el-tabs>
				<div class="pt-25 pb-25 br-8 ys-0 cur_pointer t-center mb-20 tit-22"
					style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);" @click="onSubmit">SIGN IN
				</div>
			</div>
		</div>
		<el-dialog title="Change Password" class="t-center wangjimima" :visible.sync="dialog">
			<el-input class="mb-20" v-model="lie.mail" placeholder="abc49@goodwe.com" />
			<div class="flex mb-20 forget">
				<el-input v-model="lie.code" class="int" placeholder="Verification code" />
				<div class="br-8 ml-10 ys-0 cur_pointer t-center btn tit-16">Get code</div>
			</div>
			<el-input class="mb-20" v-model="lie.newPwd" placeholder="Confirm your password" />
			<el-input class="mb-20" v-model="lie.confirmPwd" placeholder="Confirm your password again" />
			<div class="pt-24 pb-24 br-8 ys-0 cur_pointer t-center tit-22"
				style="background: linear-gradient(108deg,#fc6148 3%, #e80e1a 100%);" @click="onSubmit2">LOGIN</div>
		</el-dialog>
	</div>
</template>

<script>
	// import Header from '@/zujian/pc/Header.vue'
	let that;
	import {
		login,
		semsLogin,
		retrievePassword
	} from '@/api/login.js';
	export default {
		data() {
			return {
				activeName: 'Email',
				dialog: false,
				lie: {},
				shu: {
					account: '',
					password: ''
				},
				shu2: {
					account: '',
					password: ''
				},
				gradients: [
					['#FDEB71', '#F8D800'],
					['#ABDCFF', '#0396FF'],
					['#FEB692', '#EA5455'],
					['#CE9FFC', '#7367F0'],
					['#90F7EC', '#32CBCB'],
					['#FFF6B7', '#F6416C'],
					['#81FBB8', '#28C76F'],
					['#E2B0FF', '#9F44D3'],
					['#F97794', '#623AA2'],
					['#FCCF31', '#F55555'],
					['#F761A1', '#8C1BAB'],
					['#43CBFF', '#9708CC'],
					['#5EFCE8', '#736EFE'],
					['#FAD7A1', '#E96D71'],
					['#FFD26F', '#3677FF'],
					['#A0FE65', '#FA016D'],
					['#FFDB01', '#0E197D'],
					['#FEC163', '#DE4313'],
					['#92FFC0', '#002661'],
					['#EEAD92', '#6018DC'],
					['#F6CEEC', '#D939CD'],
					['#52E5E7', '#130CB7'],
					['#F1CA74', '#A64DB6'],
					['#E8D07A', '#5312D6'],
					['#EECE13', '#B210FF'],
					['#79F1A4', '#0E5CAD'],
					['#FDD819', '#E80505'],
					['#FFF3B0', '#CA26FF'],
					['#FFF5C3', '#9452A5'],
					['#F05F57', '#360940'],
					['#2AFADF', '#4C83FF'],
					['#FFF886', '#F072B6'],
					['#97ABFF', '#123597'],
					['#F5CBFF', '#C346C2'],
					['#FFF720', '#3CD500'],
					['#FF6FD8', '#3813C2'],
					['#EE9AE5', '#5961F9'],
					['#FFD3A5', '#FD6585'],
					['#C2FFD8', '#465EFB'],
					['#FD6585', '#0D25B9'],
					['#FD6E6A', '#FFC600'],
					['#65FDF0', '#1D6FA3'],
					['#6B73FF', '#000DFF'],
					['#FF7AF5', '#513162'],
					['#F0FF00', '#58CFFB'],
					['#FFE985', '#FA742B'],
					['#FFA6B7', '#1E2AD2'],
					['#FFAA85', '#B3315F'],
					['#72EDF2', '#5151E5'],
					['#FF9D6C', '#BB4E75'],
					['#F6D242', '#FF52E5'],
					['#69FF97', '#00E4FF'],
					['#3B2667', '#BC78EC'],
					['#70F570', '#49C628'],
					['#3C8CE7', '#00EAFF'],
					['#FAB2FF', '#1904E5'],
					['#81FFEF', '#F067B4'],
					['#FFA8A8', '#FCFF00'],
					['#FFCF71', '#2376DD'],
					['#FF96F9', '#C32BAC'],
					// 这里可以添加更多的颜色组合  
				],
				yansezu: {}
			}
		},
		mounted() {
			that = this;
			this.shu.account=this.$route.query.account
			this.shu.password=this.$route.query.pwd
			if(this.shu.account && this.shu.password){
				this.semesdenglu()
			}
			// console.log(this.$route.query)
			// console.log(this.shu.password)
			// console.log(this.$qu('userColorMaps'))
			// localStorage.clear();
		},
		methods: {
			hoverItem(index) {

			},
			getHoverImage(index) {

			},
			handleClick() {

			},
			onSubmit() {
				const params = new URLSearchParams() // 创建对象
				params.append('account', this.shu.account) // 封装对象
				params.append('password', this.shu.password) // 封装对象
				if (this.activeName == 'Email') {

					login(params).then(shu => {
						if (shu.code == '200') {
							this.$cun('kouling', shu.data.token)
							this.$cun('yonghuming', shu.data.nickname)
							this.$cun('guserid', shu.data.id)
							if(shu.data.id){
								let gradient =this.$qu('uColor2_'+shu.data.id);
								// console.log(gradient.length,'gradient1')
								if (gradient.length<=0) {
									const index = Math.floor(Math.random() * this.gradients.length);
									gradient = this.gradients[index];
									let yansess=gradient[0]+','+gradient[1]
									// console.log(yansess,'yansess')
									this.$cun('uColor2_'+shu.data.id,yansess);
								}
								// console.log(this.$qu('uColor2_'+shu.data.id),'gradient2')
							}
							// this.yansezu = this.$qu('userColorMapsx');
							// let gradient = this.yansezu[shu.data.id];
							// if (!gradient) {
							// 	const index = Math.floor(Math.random() * this.gradients.length);
							// 	const gradient = this.gradients[index];
							// 	this.yansezu[shu.data.id] = gradient; // 存储对应关系
							// 	console.log(this.yansezu)
							// 	this.$cun('userColorMapsx', this.yansezu)
							// }
							// console.log(this.$qu('userColorMapsx'))
							this.$message({
								showClose: true,
								message: 'Login successful',
								type: 'success',
								offset: '350',
								duration:2000
							})
							setTimeout(() => {
								this.$dakai('/')
							}, 500)
						}
						// console.log(shu)
					})
				} else {
					semsLogin(params).then(shu => {
						if (shu.code == '200') {
							this.$cun('kouling', shu.data.token)
							this.$cun('yonghuming', shu.data.nickname ? shu.data.nickname : shu.data.account)
							this.$cun('guserid', shu.data.id)
							if(shu.data.id){
								let gradient =this.$qu('uColor2_'+shu.data.id);
								if (gradient.length<=0) {
									const index = Math.floor(Math.random() * this.gradients.length);
									gradient = this.gradients[index];
									let yansess=gradient[0]+','+gradient[1]
									this.$cun('uColor2_'+shu.data.id,yansess);
								}
							}
							this.$message({
								showClose: true,
								message: 'Login successful',
								type: 'success',
								offset: '350',
								duration: 2000
							})
							setTimeout(() => {
								this.$dakai('/')
							}, 500)
						}
						// console.log(shu)
					})
				}

				// if(this.shu.name=='name' && this.shu.pass=='123456') {
				// 	this.$dakai('plus_details')
				// }
			},
			semesdenglu(){
				const params = new URLSearchParams() // 创建对象
				params.append('account', atob(this.shu.account)) // 封装对象
				params.append('password', atob(this.shu.password)) // 封装对象
				const loading = this.$loading({
				target: this.$refs.caogaoxiang,
				  lock: true,
				  text: 'Loading',
				  spinner: 'el-icon-loading',
				  background: 'rgba(0, 0, 0, 0.2)',
				  customClass: 'custom-loading'
				});
				semsLogin(params).then(shu => {
					if (shu.code == '200') {
						loading.close();
						this.$cun('kouling', shu.data.token)
						this.$cun('yonghuming', shu.data.nickname ? shu.data.nickname : shu.data.account)
						this.$cun('guserid', shu.data.id)
						if(shu.data.id){
							let gradient =this.$qu('uColor2_'+shu.data.id);
							if (gradient.length<=0) {
								const index = Math.floor(Math.random() * this.gradients.length);
								gradient = this.gradients[index];
								let yansess=gradient[0]+','+gradient[1]
								this.$cun('uColor2_'+shu.data.id,yansess);
							}
						}
						this.$message({
							showClose: true,
							message: 'Login successful',
							type: 'success',
							offset: '350',
							duration: 2000
						})
						setTimeout(() => {
							this.$dakai('/')
						}, 500)
					}
					// console.log(shu)
				})
			},
			onSubmit2() {

			}
		}
	}
</script>

<style lang="scss" scoped>
	.login {
		::v-deep.custom-loading .el-loading-text,::v-deep.custom-loading .el-icon-loading {
		  color: #ff0000; /* 设置文字颜色为红色，你可以根据需要修改 */
		}
		background: url('../../../assets/pc/login.png') no-repeat;
		background-size: cover;
		height: 100vh;

		::v-deep .el-tabs {
			height: 76%;
			display: flex;
			flex-direction: column;
		}

		::v-deep .el-tabs__nav-wrap::after {
			background-color: #F2F2F2;
		}

		::v-deep .is-active {
			color: #333333;
			font-weight: 700;
		}

		::v-deep .el-tabs__nav {
			padding-top: .3rem;
			padding-bottom: .15rem;
		}

		::v-deep .el-tabs__active-bar {
			background-color: #E60012;
		}

		::v-deep .el-tabs__item {
			font-size: .34rem;
			font-family: "montserLight";
		}

		::v-deep .el-tabs__item:hover {
			color: #E60012;
		}

		::v-deep .juzhong {
			background: #ffffff;
			border-radius: 11px;
			width: 7.13rem;
			padding-top: .3rem;
			max-width: 96%;
			min-height: 5.81rem;
			background: #ffffff;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			input {
				border: none;
				background: transparent;
				height: auto;
				line-height: initial;
				padding: 0;
				font-size: .18rem;
			}

			.el-input__inner::placeholder,
			i {
				color: #999999;
			}
		}

		::v-deep .wangjimima {
			width: 100%;
			display: flex;
			align-items: center;

			.el-dialog {
				width: 766px;
				max-width: 60%;
				margin: auto;
			}

			.el-input__inner {
				color: #999999;
				height: .7rem;
				min-height: 40px;
				padding: 0 .3rem;
			}

			.forget .int {
				flex: 1;
			}

			.forget .btn {
				padding: 0 .4rem;
				display: inline-flex;
				align-items: center;
				background: linear-gradient(-26deg, #e70a16 0%, #ff785c 100%);
			}
		}

		::v-deep .el-dialog__title {
			font-size: .39rem;
			font-family: "montserMedium";
		}

		::v-deep .el-dialog__header {
			padding: .89rem 0 0;
		}

		::v-deep .el-dialog__body {
			padding: .5rem;
		}
	}


	// ==========================================================================================================================================================================
	// 响应式
	@media screen and (max-width: 767px) {
		.for_nr {
			width: 90%;
		}

		.login ::v-deep .wangjimima .el-dialog {
			max-width: 90%;
		}
	}
</style>